import { FormInput } from 'Shared/components';
import React, { useEffect, useState } from 'react';

import { booleanValueMapping } from 'Shared/utils';
import styles from './styles.module.css';
import { useAppContext, usePurchaseContext } from 'QuoteApp/services/providers';
import { Alert } from '@clearcover/atlas';

type SMSConsentType = {
  eSignatureSMSConsent: boolean | undefined;
  setESignatureSMSConsent: (consent: boolean) => void;
};

export const SMSConsent = ({
  eSignatureSMSConsent,
  setESignatureSMSConsent,
}: SMSConsentType) => {
  const { details } = useAppContext();

  const {
    eSignatureErrors,
    setESignatureErrors,
    signaturePacketSendAttempt,
  } = usePurchaseContext();

  const [acceptedConsent, setAcceptedConsent] = useState<string>(
    booleanValueMapping[
      eSignatureSMSConsent !== undefined ? eSignatureSMSConsent.toString() : ''
    ]
  );

  useEffect(() => {
    if (signaturePacketSendAttempt) {
      setAcceptedConsent(
        booleanValueMapping[
          signaturePacketSendAttempt.send_link_by_sms.toString()
        ]
      );
      setESignatureSMSConsent(signaturePacketSendAttempt.send_link_by_sms);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signaturePacketSendAttempt]);

  const onOptionChange = (value: string) => {
    setAcceptedConsent(value);
    setESignatureSMSConsent(value === booleanValueMapping['true']);

    if (eSignatureErrors?.smsConsent) {
      const updatedErrors = { ...eSignatureErrors };
      delete updatedErrors.smsConsent;
      setESignatureErrors(updatedErrors);
    }
  };

  return (
    <div className={styles.consentMessageContainer}>
      <h4>
        Would the customer like to receive these documents via text message?
      </h4>
      <p>
        This consent authorizes Clearcover to contact the customer for document
        signature signing.{' '}
      </p>
      <div className={styles.consentMessageOptions}>
        <FormInput
          variant="radio"
          name={'receive-text-message'}
          value="Yes"
          label={`Yes, the customer accepts text communication to ${
            details.contactInfo[details.principalInsuredId].phoneNumber.value
          }`}
          checked={acceptedConsent === 'Yes'}
          className={styles.consentMessageOptionFirst}
          onChecked={() => onOptionChange('Yes')}
          disabled={!!signaturePacketSendAttempt}
        />
        <FormInput
          variant="radio"
          name={'receive-text-message'}
          value="No"
          label="No, the customer declines text communication"
          checked={acceptedConsent === 'No'}
          className={styles.consentMessageOption}
          onChecked={() => onOptionChange('No')}
          disabled={!!signaturePacketSendAttempt}
        />
      </div>
      {eSignatureErrors?.smsConsent && (
        <div data-testid="esignature-sms-error-notification">
          <Alert
            message={eSignatureErrors.smsConsent}
            className={styles.eSignatureError}
          />
        </div>
      )}
    </div>
  );
};
